import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, FormInput, FormSelect } from '../../components'
import { newProject, fetchOrganizations } from '../../api'
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/project-actions';
import { notify } from '../../utils';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal_visible: true,
            organization: undefined,
            organizations: [],
        }
        this.getData = this.getData.bind(this);
        this.onRequest = this.onRequest.bind(this);
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        fetchOrganizations(this.props.user.token)
            .then((organizations) => this.setState({ organizations }))
            .catch((err) => {
                alert(err.message);
            })
    }
    onRequest(event) {
        if (event) event.preventDefault();
        if (this.state.organization) {
            newProject(
                this.props.user.token,
                this.state.organization,
                {
                    ...this.state
                }
            ).then((project) => {
                this.props.retrieve(this.props.user.token);
                this.props.replace(`/projects/${this.state.organization}/${project.code}`);
            }).catch(err => {
                alert(err.message);
            })
            return;
        }
        notify('Validation Error', 'Missing organization code', 'error');
    }
    render() {
        return (
            <Modal
                visible={this.state.modal_visible}
                onClose={() => this.setState({ modal_visible: false }, this.props.back)}
                title={'New Project'}
                action_text={"ADD PROJECT"}
                onActionClick={this.onRequest}>
                <form onSubmit={this.onRequest}>
                    <FormInput
                        onChange={(name) => {
                            this.setState({ name });
                        }}
                        required
                        value={this.state.name}
                        placeholder="Title" />
                    <FormInput
                        onChange={(description) => {
                            this.setState({ description });
                        }}
                        required
                        value={this.state.description}
                        placeholder="Brief description" />
                    <FormSelect
                        onChange={(option) => {
                            let { organization } = this.state;
                            if (option) organization = option.value;
                            else organization = undefined;
                            this.setState({ organization });
                        }}
                        placeholder="Organizations"
                        searchable required
                        value={this.state.organization}
                        options={this.state.organizations.map(org => ({ label: `${org.name} - ${org.code}`, value: org.code }))} />
                </form>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    },
    retrieve(token) {
        dispatch(retrieve(token));
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/Projects/Form.js